module.exports = __webpack_public_path__ + "img/what-we-value.514acf2d.webp";